import type { ReactNode } from "react";

import { cn } from "@krea/shared/utils";

export const BankIDAuthenticationState = ({
  children,
  error,
  className,
}: {
  children?: ReactNode;
  error?: boolean;
  className?: string;
}) => {
  return (
    <div
      className={cn(
        "text-base-strong",
        "rounded-sm text-center",
        { "bg-red text-white p-6": error },
        className,
      )}
    >
      {children}
    </div>
  );
};
